import { Observable } from 'rxjs';
import { TokensReplaceMap } from './tokens';

export abstract class TokensService<T = any> {
  abstract getTokensMap(): Observable<TokensReplaceMap[]>;
  abstract replaceTokens(data: T[]): Observable<any>;
  abstract replaceToken(data: T, config: any): Observable<any>;
  abstract replaceTextTokens(text: string): Observable<string>;
}
